import React, { useEffect, useMemo, useState } from "react";
import DataTable from "react-data-table-component";
import SpinnerCargando from "../SpinnerCargando";
import instanciaAxios from "../../../miscelaneo/instanciaAxios";
import { FaSearch } from "react-icons/fa";

const TablaCuentaTesoreria = ({ setCuentaSeleccionada, descripcion = "" }) => {
  const [cuentas, setCuentas] = useState([]);
  const [filtro, setFiltro] = useState("");
  const [cargando, setCargando] = useState(true);

  useEffect(() => {
    const cargarDatos = async () => {
      try {
        setCargando(true);
        const respuesta = await instanciaAxios.get("/cuenta_tesoreria");
        setCuentas(respuesta.status === 200 ? respuesta.data : []);
      } catch (error) {
        console.error("Error al cargar cuentas de tesorería:", error);
        setCuentas([]);
      } finally {
        setCargando(false);
      }
    };

    cargarDatos();
  }, []);

  const datosFiltrados = useMemo(() => {
    if (!filtro) return cuentas;
    const filtroLower = filtro.toLowerCase();
    return cuentas.filter((cuenta) =>
      [
        cuenta.descripcion,
        cuenta.numero_cuenta,
        cuenta.tipo_cuenta_tesoreria,
        cuenta.moneda,
        cuenta.banco,
      ]
        .map((campo) => (campo || "").toString().toLowerCase())
        .some((valor) => valor.includes(filtroLower))
    );
  }, [cuentas, filtro]);

  const columns = useMemo(
    () => [
      {
        name: "Descripción",
        selector: (row) => row.descripcion,
        sortable: true,
        cell: (row) => (
          <div className="flex items-center gap-2">
            <span>{row.descripcion}</span>
            {row.permite_sesion_caja && (
              <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-semibold bg-green-100 text-green-800 whitespace-nowrap">
                Caja
              </span>
            )}
          </div>
        ),
      },
      { name: "Número de Cuenta", selector: (row) => row.numero_cuenta, sortable: true },
      { name: "Tipo de Cuenta", selector: (row) => row.tipo_cuenta_tesoreria, sortable: true },
      { name: "Moneda", selector: (row) => row.moneda, sortable: true },
      { name: "Banco", selector: (row) => row.banco, sortable: true },
    ],
    []
  );

  const handleRowClick = (cuenta) => {
    setCuentaSeleccionada(cuenta.id_cuenta_tesoreria);
  };

  if (cargando) return <SpinnerCargando />;
  if (cuentas.length === 0)
    return (
      <div className="text-center text-gray-500 mt-5">
        No se encontraron cuentas de tesorería.
      </div>
    );

  return (
    <DataTable
      title={
        <>
          <h2 className="text-xl font-semibold text-center font-cascadia text-black">
            Cuentas de Tesorería
          </h2>
          {descripcion && (
            <p className="text-sm text-gray-500 text-center">{descripcion}</p>
          )}
        </>
      }
      columns={columns}
      data={datosFiltrados}
      pagination
      highlightOnHover
      dense
      onRowClicked={handleRowClick}
      subHeader
      subHeaderComponent={
        <div className="w-full relative">
          <FaSearch className="absolute right-3 top-1/2 -translate-y-1/2 text-color-secundario" />
          <input
            type="text"
            placeholder="Buscar..."
            className="w-full border px-3 py-1 rounded-xl"
            value={filtro}
            onChange={(e) => setFiltro(e.target.value)}
          />
        </div>
      }
    />
  );
};

export default TablaCuentaTesoreria;
